import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as BootstrapModal, Button as BootstrapButton } from 'react-bootstrap';

import { Modal } from '@/components/common';

interface IModalClearShifts {
  showModal: boolean;
  hideModal: () => void;
  handleClear: () => void;
}

const ModalClearShifts = ({ showModal, hideModal, handleClear }: IModalClearShifts): React.ReactElement => {
  const { t } = useTranslation();
  const [isRequestProcessing, setIsRequestProcessing] = useState<boolean>(false);

  const handleClose = () => {
    setIsRequestProcessing(false);
    hideModal();
  };

  const handleClearShifts = () => {
    setIsRequestProcessing(false);
    hideModal();
    handleClear();
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title style={{ color: '#dc3545' }}>
          {t`mySchedule.pickUpShiftCart.clearSelectedShiftsModal.title`}
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>{t`mySchedule.pickUpShiftCart.clearSelectedShiftsModal.body`}</BootstrapModal.Body>
      <BootstrapModal.Footer>
        <BootstrapButton variant="secondary" onClick={handleClose}>
          {t`common.btnCancel`}
        </BootstrapButton>
        <BootstrapButton variant="danger" onClick={handleClearShifts} disabled={isRequestProcessing}>
          {t`common.btnClear`}
        </BootstrapButton>
      </BootstrapModal.Footer>
    </Modal>
  );
};

export { ModalClearShifts };
